// extracted by mini-css-extract-plugin
module.exports = {"nextEl":"Carousel_nextEl__2gacx","prevEl":"Carousel_prevEl__2drTs","slide":"Carousel_slide__3eus3","pages":"Carousel_pages__2_b5w"};